"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("mapbox-gl/dist/mapbox-gl.css");
var _react = _interopRequireWildcard(require("react"));
var _reactMapGl = require("react-map-gl");
var _lodash = _interopRequireDefault(require("lodash.findlast"));
var _geojsonExtent = _interopRequireDefault(require("@mapbox/geojson-extent"));
var _constants = require("../constants");
var _useChartData = require("../hooks/useChartData");
var _useColor = require("../hooks/useColor");
var _BaseMap = _interopRequireDefault(require("./BaseMap"));
var _useFilter = require("../hooks/useFilter");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ChoroplethMap = /*#__PURE__*/(0, _react.memo)(chartProps => {
  const {
    chart,
    boundaries,
    chartColors
  } = chartProps;
  const colorConfig = chart.colors || chartColors;
  if (colorConfig && !colorConfig.settings) {
    colorConfig.settings = {
      direction: "ascending",
      divergingMidPoint: 0,
      steps: 6
    };
  }
  const {
    yCol,
    tooltipCol,
    componentProps,
    seriesCol,
    regions
  } = chart;
  const {
    colorScheme = "sequential"
  } = componentProps;
  const {
    filter,
    filterComponent
  } = (0, _useFilter.useFilter)(chartProps);
  const {
    data
  } = (0, _useChartData.useChartData)(chart, filter, true);
  const {
    calculateColorStops
  } = (0, _useColor.useColor)(colorConfig, colorScheme);
  const vBoundaries = boundaries[regions.setup.version];
  function extractChoroplethFeature(region) {
    const series = data.find(d => d.seriesKey === region.geoId);
    let point = {
      [_constants.COL_GEO_ID]: region.geoId,
      year: chart.dataView.latestYear.toString()
    };
    if (series && series.points) {
      var _chart$dataView$colum, _chart$dataView$colum2;
      point = (0, _lodash.default)(series.points);
      if (!point || point[yCol] === undefined || isNaN(Number(point[yCol])) && colorScheme !== "categorical") {
        return null;
      }
      if (!isNaN(Number(point[yCol]))) {
        // @ts-ignore
        point[yCol] = Number(point[yCol]);
      } else if (!((_chart$dataView$colum = chart.dataView.columns[yCol]) !== null && _chart$dataView$colum !== void 0 && (_chart$dataView$colum2 = _chart$dataView$colum.categories[point[yCol]]) !== null && _chart$dataView$colum2 !== void 0 && _chart$dataView$colum2.visible)) {
        return null;
      }
    } else {
      return null;
    }
    const feature = {
      ...region.feature
    };
    feature.properties = {
      ...feature.properties,
      ...point
    };
    return feature;
  }
  const areas = (0, _react.useMemo)(() => {
    const featureCollection = {
      type: "FeatureCollection",
      features: []
    };
    if (!vBoundaries) {
      return featureCollection;
    }
    if (regions.setup.sorroundings !== "none" && regions.setup.container !== "none" && regions !== null && regions !== void 0 && regions.peers) {
      const peerRegions = regions.peers.map(geoId => vBoundaries[geoId]).filter(Boolean);
      const features = peerRegions.map(extractChoroplethFeature).filter(Boolean);
      featureCollection.features.push(...features);
    }
    if (regions !== null && regions !== void 0 && regions.related) {
      const relatedRegions = regions.related.map(geoId => vBoundaries[geoId]).filter(Boolean);
      const features = relatedRegions.map(extractChoroplethFeature).filter(Boolean);
      featureCollection.features.push(...features);
    }
    if (regions !== null && regions !== void 0 && regions.main) {
      const mainRegion = vBoundaries[regions.main];
      if (mainRegion) {
        const feature = extractChoroplethFeature(mainRegion);
        if (feature) {
          featureCollection.features.push(feature);
        }
      }
    }
    if (regions.setup.segmentBy !== "none" && regions !== null && regions !== void 0 && regions.segments) {
      const segmentRegions = regions.segments.map(geoId => vBoundaries[geoId]).filter(Boolean);
      const features = segmentRegions.map(extractChoroplethFeature).filter(Boolean);
      featureCollection.features.push(...features);
    }
    return featureCollection;
  }, [regions.setup, data, vBoundaries]); // !data?? 

  function valuesForChoropleth(collection) {
    if (colorScheme !== "categorical") {
      if (isNaN(Number(collection.features[0].properties[yCol]))) {
        console.warn("Non numeric value in sortedValues for non-categorical variable: ".concat(collection.features[0].properties[yCol]));
        return [];
      }
      return collection.features.map(f => Number(f.properties[yCol])).sort((a, b) => a - b);
    } else {
      return Array.from(new Set(collection.features.map(f => f.properties[yCol]))).sort((a, b) => {
        const col = yCol.startsWith("_") ? yCol.split("|")[1] : yCol;
        const categories = chart.dataView.columns[col].categories;
        if (!categories) return 0;
        return categories[a].position - categories[b].position;
      });
    }
  }
  ;
  const sortedValues = (0, _react.useMemo)(() => {
    if (areas.features.length > 0) {
      return valuesForChoropleth(areas);
    }
    return [];
  }, [areas, yCol, colorScheme, areas]);
  const colorStops = (0, _react.useMemo)(() => calculateColorStops(sortedValues), [sortedValues]);
  const flatColorStops = colorStops.flat();
  const createPopup = (props, mapRef) => {
    var _chart$dataView$colum3;
    if (areas.features.length === 0) {
      return;
    }
    const geoIdCol = seriesCol === _constants.COL_RELATED_GEO_ID ? _constants.COL_RELATED_GEO_ID : _constants.COL_GEO_ID;
    const featureCollection = {
      type: "FeatureCollection",
      features: areas.features.filter(feature => feature.properties[geoIdCol] === props[geoIdCol])
    };
    const bounds = (0, _geojsonExtent.default)(featureCollection);
    const area = {
      bottomLeft: {
        lng: bounds[0],
        lat: bounds[1]
      },
      topRight: {
        lng: bounds[2],
        lat: bounds[3]
      }
    };
    const mapBounds = mapRef.current.getMap().getBounds().toArray();
    const mapBoundsObj = {
      bottomLeft: {
        lng: mapBounds[0][0],
        lat: mapBounds[0][1]
      },
      topRight: {
        lng: mapBounds[1][0],
        lat: mapBounds[1][1]
      }
    };
    const mapHeight = mapBoundsObj.topRight.lat - mapBoundsObj.bottomLeft.lat;
    const mapWidth = mapBoundsObj.topRight.lng - mapBoundsObj.bottomLeft.lng;
    // From the top of the area to the bottom of the map
    const topOffset = (area.topRight.lat - mapBoundsObj.bottomLeft.lat) / mapHeight;
    // From the bottom of the area to the bottom of the map
    const bottomOffset = (area.bottomLeft.lat - mapBoundsObj.bottomLeft.lat) / mapHeight;
    // From the left of the area to the left of the map
    const leftOffset = (area.bottomLeft.lng - mapBoundsObj.bottomLeft.lng) / mapWidth;
    // From the right of the area to the left of the map
    const rightOffset = (area.topRight.lng - mapBoundsObj.bottomLeft.lng) / mapWidth;

    // Horizontal center of the area
    let lng = (area.bottomLeft.lng + area.topRight.lng) / 2;
    let lat = area.topRight.lat;
    let anchor = "bottom";
    if (topOffset >= 0.8) {
      lat = area.bottomLeft.lat;
      anchor = "top";
      if (bottomOffset <= 0.15) {
        // Center tooltip in area if the area uses most of the vertical space
        lat = (area.topRight.lat + area.bottomLeft.lat) / 2;
        anchor = "center";
      }
    }
    if (anchor !== "center") {
      if (rightOffset >= 0.85) {
        lng = area.bottomLeft.lng;
        anchor = anchor === "bottom" ? "bottom-right" : "top-right";
      } else if (leftOffset <= 0.15) {
        lng = area.topRight.lng;
        anchor = anchor === "bottom" ? "bottom-left" : "top-left";
      }
    }
    const label = ((_chart$dataView$colum3 = chart.dataView.columns[seriesCol].categories[props[geoIdCol]]) === null || _chart$dataView$colum3 === void 0 ? void 0 : _chart$dataView$colum3.label) || "";
    return {
      geoId: props[_constants.COL_GEO_ID],
      label,
      tooltipValue: props[tooltipCol],
      lng,
      lat,
      anchor
    };
  };
  if (!vBoundaries) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_BaseMap.default, (0, _extends2.default)({}, chartProps, {
    sortedValues: sortedValues,
    createPopup: createPopup,
    flatColorStops: flatColorStops,
    areas: areas,
    filterComponent: filterComponent
  }), (areas === null || areas === void 0 ? void 0 : areas.features.length) > 0 && colorStops.length > 0 && /*#__PURE__*/_react.default.createElement(_reactMapGl.Source, {
    id: "".concat(chart.id, "|segments"),
    type: "geojson",
    data: areas
  }, /*#__PURE__*/_react.default.createElement(_reactMapGl.Layer, {
    id: "".concat(chart.id, "|interactive-layer"),
    type: "fill",
    paint: {
      "fill-color": colorScheme === "categorical" ? ["match", ["get", yCol], ...flatColorStops, "#666666"] : {
        property: yCol,
        stops: colorStops
      },
      "fill-opacity": 0.7
    }
  })));
});
var _default = ChoroplethMap;
exports.default = _default;